<script>
  import {mapGetters, mapActions} from 'vuex';

  export default {

    computed: {

      ...mapGetters('cms/playbook', {
        playbookCms: 'props',
      }),

    },

    methods: {

      ...mapActions('cms/playbook', {
        initializePlaybookCms: 'initialize',
        loadPlaybooks: 'load',
        createPlaybook: 'createPlaybook',
        updatePlaybook: 'updatePlaybook',
        deletePlaybook: 'deletePlaybook',
        createBucket: 'createBucket',
        updateBucket: 'updateBucket',
        deleteBucket: 'deleteBucket',
        createPlay: 'createPlay',
        updatePlay: 'updatePlay',
        deletePlay: 'deletePlay',
      }),

      async initializePlaybookCmsContext () {
        await this.initializePlaybookCms();
        await this.loadPlaybooks();
      },

    },
  };

</script>
